module.exports = __webpack_public_path__ + "assets/img/head-msg-back.9ee95ad0.png";